import logo from "assets/img/logo.png";

/**
 * Main App Component Controller
 * @ngInject
 */
class AppController {
	constructor(labelService, $rootScope, $scope, $location, $timeout) {
		this.logo = logo;

		this.systemTitle = labelService.getLabelByPageAndKey("global", "systemTitle").titulo;
		$rootScope.$on("labelService:labelsChanged", () => {
			this.systemTitle = labelService.getLabelByPageAndKey("global", "systemTitle").titulo;
		});

        $rootScope.$on('$locationChangeSuccess', function() {

            $rootScope.$watch(function () {return $location.path()}, function (newLocation, oldLocation) {
                $timeout(function () {
                    $('.container').animate({scrollTop: 0}, 400);
                }, 50);

            	if(newLocation === '/pergunta-seguranca' && oldLocation === '/alterar-senha') {
                    history.pushState({}, '','senhaop/#/alterar-senha');
                }
                if(newLocation === '/alterar-senha' && oldLocation === '/senha-alterada') {
                    history.pushState({}, '','senhaop/#/senha-alterada');
                }
            });

        });
	}
}

export default AppController;



// WEBPACK FOOTER //
// ./src/app/app.controller.js